import { supportLink } from '@/config'
import clsx from 'clsx'

export const SupportLink = ({
  className,
  children = 'contact support',
}: {
  className?: string
  children?: React.ReactNode
}) => {
  return (
    <a
      href={supportLink}
      id="get-in-touch"
      className={clsx('text-sky-500 hover:underline', className)}
    >
      {children}
    </a>
  )
}
